import { i18n } from '@/plugins/i18n'
import {ShaparakDownloadedFileTypesStr, shaparakTypeVariant} from "@/constants/ShaparakDownloadedFileTypes";
import LogoColumn from "@/views/collective/components/logo-column.vue";

const logoTemplate = (row, index, datatable) => {
    let template = new LogoColumn({
        props: {
            row,
            index,
            datatable,
        },
        i18n,
    })

    template.row = row
    template.index = index
    template.datatable = datatable

    return template.$mount().$el
}
export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 50,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'shop',
        title: i18n.t('reports.terminals.shop_name'),
        sortable: false,
        width: 120,
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
        template:(row) =>{
            let url = "gateways";
            return '<a href="/' + url + '/' + row.shop_id + '/details">'+row.shop+'</a>';
        }
    },
    {
        field: 'acceptor_name',
        title: i18n.t('reports.terminals.acceptor_name'),
        sortable: false,
        width: 60,
        textAlign: 'center',
        template:(row) =>{
            let url = "users";
            return '<a href="/' + url + '/' + row.acceptor_id + '/details">'+row.acceptor_name+'</a>';
        }
    },
    {
        field: 'psp',
        title: i18n.t('reports.terminals.psp'),
        sortable: false,
        width: 90,
        template: (row, index, datatable) => {
            return logoTemplate(row, index, datatable)
        },
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('reports.terminals.amount'),
        sortable: false,
        width: 70,
        textAlign: 'center',
    },
    {
        field: 'terminal_balance',
        sortable: false,
        title: i18n.t('reports.terminals.terminal_balance'),
        textAlign: 'center',
        type: 'number',
        width: 70
    },
    {
        field: 'type',
        sortable: false,
        title: i18n.t('reports.terminals.type'),
        textAlign: 'center',
        template: (row) => {
            let file_type  = ShaparakDownloadedFileTypesStr.get(row.type)
            let type_class = 'badge-'+shaparakTypeVariant(row.type)

            return `<div class='badge text-white ${type_class}' >`+ file_type +'</div>'
        },
        width: 70
    },
    {
        field: 'payment_date',
        sortable: true,
        title: i18n.t('reports.terminals.payment_date'),
        textAlign: 'center',
        width: 70
    },
]